import { Container } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { Editors, MDEEditor } from "../../../Constant";
import MdeExampleOne from "./MdeExampleOne";
import MdeExampleTwo from "./MdeExampleTwo";

const SimpleMdeEditorsContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={MDEEditor} parent={Editors} title={MDEEditor} />
      <Container fluid>
        <MdeExampleOne />
        <MdeExampleTwo />
      </Container>
    </>
  );
};

export default SimpleMdeEditorsContainer;
